module.exports = __webpack_public_path__ + "static/paris-003.thumb-a6610f68a2d5f1388d6945594e6cb3a1.jpg";